import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { App } from "./App.js";

export const root = createRoot(document.getElementById("quasar-as-app"));

root.render(createElement(App, null));

